import { useTenant } from '@emerald-works-nova/auth'
import consts from '../consts'
import useProducts from './useProducts'

export function useDisplayAddToPlaylist () {
  const tenant = useTenant()
  // PENG-3783: flag read centralised in useProducts; the club exemption stays here.
  const { hasPlaylistsAccess } = useProducts()
  const displayPlaylist = hasPlaylistsAccess || tenant.pk === consts.DEFAULT_CLUB_PK
  return displayPlaylist
}
